module.exports = __webpack_public_path__ + "static/media/sessionExpired.a34149de.svg";